"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _defaultThemeColors = _interopRequireDefault(require("./defaultThemeColors"));

var _constant = require("./constant");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Default theme
// Constants
var ThemeContext = /*#__PURE__*/_react.default.createContext({
  currentTheme: _constant.MODE.LIGHT,
  Colors: _defaultThemeColors.default,
  setScheme: () => {}
});

var _default = ThemeContext;
exports.default = _default;